/**
 * src/lib/portal-credit.js — the "Powered by Tattoo Lab" credit at the foot
 * of every client-facing portal page.
 *
 * Shared by PortalFooter.jsx (what a visitor sees once the SPA has loaded)
 * and src/worker.js (the same link written into the HTML of a studio's
 * /book and /gallery pages before any JavaScript runs), so the two copies
 * of the credit can't drift apart.
 *
 * It's a backlink from every studio's booking and gallery page to the
 * marketing site, so the href is www, not the app apex: the apex just
 * bounces to /login, and a link there passes nothing to www.
 */

/** Words before the link. */
export const PORTAL_CREDIT_PREFIX = 'Powered by';

/** The link's text. The brand name on its own — see PortalFooter.jsx. */
export const PORTAL_CREDIT_LABEL = 'Tattoo Lab';

/** Where the credit links to. Absolute: it's followed from studio subdomains. */
export const PORTAL_CREDIT_URL = 'https://www.tattoo-lab.co.uk/';
